import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en/translation.json';
import es from '../locales/es/translation.json';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

const resources = {
    en: { translation: en },
    es: { translation: es }
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        supportedLngs: ['en', 'es'],
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage']
        }
    });

// keep Dayjs locale in sync with i18n language
const mapI18nToDayjs = (lng) => (lng === 'en' ? 'en' : lng);
dayjs.locale(mapI18nToDayjs(i18n.language || 'en'));
i18n.on('languageChanged', (lng) => {
    dayjs.locale(mapI18nToDayjs(lng));
});

export default i18n;
